import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'app-search-status-chip',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <span
      class="inline-flex h-6 min-w-26 max-w-40 items-center justify-center truncate rounded px-2 text-sm font-medium leading-none"
      [style.background-color]="backgroundColor()"
      [style.color]="textColor()"
      role="status"
    >
      {{ name() }}
    </span>
  `,
})
export class SearchStatusChipComponent {
  readonly name = input.required<string>();
  readonly backgroundColor = input.required<string>();
  readonly textColor = input.required<string>();
}
